unless window.gs?
  gs = {}
  window.gs = gs
else
  gs = window.gs

summary = {}
gs.summary = summary

get_interval = (interval_name, base_time = null)->
  unless base_time?
    base_time = new Date()

  switch (interval_name)
    # Type of widget: Compare progress so far today against corresponding part of yesterday
    #                 Restrict to business days (do we need a param for list of business days?)
    when "24hr"
      # Today vs the corresponding beginning of yesterday
      prev_start: new Date(base_time).add(-2).days()
      prev_end: new Date(base_time).add(-1).days()
      prev_title: "Yesterday"
      start: new Date(base_time).add(-1).days()
      end: base_time
      title: "Last 24 Hours"
      comp_str: "this time yesterday"
    when "today"
      # Today vs the corresponding beginning of yesterday
      prev_start: new Date(base_time).clearTime().add(-1).days()
      prev_end: new Date(base_time).add(-1).days()
      prev_title: "Yesterday"
      start: new Date(base_time).clearTime()
      end: base_time
      title: "Today"
      comp_str: "this time yesterday"
    when "today_yesterday_complete"
      # today vs all of yesterday
      prev_start: new Date(base_time).clearTime().add(-1).days()
      prev_end: new Date(base_time).clearTime()
      prev_title: "Yesterday"
      start: new Date(base_time).clearTime()
      end: base_time
      title: "Today"
      comp_str: "this time yesterday"
    when "workday"
      # today vs the previous workday
      last_weekday = new Date(base_time)

      loop
        last_weekday.add(-1).days()
        break if last_weekday.isWeekday()

      return {
        prev_start: new Date(last_weekday).clearTime()
        prev_end: new Date(last_weekday)
        prev_title: last_weekday.toString('dddd')
        start: new Date(base_time).clearTime()
        end: base_time
        title: "Today"
        comp_str: "this time #{last_weekday.toString('dddd')}"
      }
    when "week"
      # The past 7 days vs the previous 7 days
      prev_start: new Date(base_time).clearTime().add(-14).days()
      prev_end: new Date(base_time).clearTime().add(-7).days()
      prev_title: "Last Week"
      start: new Date(base_time).clearTime().add(-7).days()
      end: base_time
      title: "This Week"
      comp_str: "the 7 days before"
    when "work_week"
      # The past few days since monday vs the corresponding portion of last week.
      prev_start: new Date(base_time).clearTime().last().monday().last().monday()
      prev_end: new Date(base_time).add(-7).days()
      prev_title: "Last Week"
      start: new Date(base_time).clearTime().last().monday()
      end: base_time
      title: "This Week"
      comp_str: "this part of last week"
    when "month"
      prev_start: new Date(base_time).clearTime().add(-60).days()
      prev_end: new Date(base_time).clearTime().add(-30).days()
      prev_title: "Last Month"
      start: new Date(base_time).clearTime().add(-30).days()
      end: base_time
      title: "This Month"
      comp_str: "this part of last month"
    when "cal_month"
      prev_start: new Date(base_time).clearTime().set({day:1}).add(-1).months()
      prev_end: new Date(base_time).clearTime().set({day:1})
      prev_title: "Last Month"
      start: new Date(base_time).clearTime().set({day:1})
      end: base_time
      title: "This Month"
      comp_str: "this part of last month"

    else # Use the "today" case
      prev_start: new Date(base_time).clearTime().add(-1).days()
      prev_end: new Date(base_time).add(-1).days()
      prev_title: "Yesterday"
      start: new Date(base_time).clearTime()
      end: base_time
      title: "Today"
      comp_str: "this time yesterday"

make_note_array = (note) ->
  for own type of note
    text = note[type]
    continue unless text? and text != ""

    css = {'note':true}
    css[note_type] = true for note_type in type.split(' ')

    {'type':type, 'css':css, 'text':text}


class UiWidget
  module_sizes: {1: "", 2: "middle", 3:"big", 4: "huge"}

  constructor: ()->
    @title =       ko.observable ""
    @type =        ko.observable ""
    @is_good =     ko.observable "" # "good", "bad" or ""
    @unit_prefix = ko.observable ""
    @unit_suffix = ko.observable ""
    @unit_detail = ko.observable ""
    @main_size =   ko.observable "big"
    @module_size = ko.observable 1
    @module_height = ko.observable 2
    @widget_type = ko.observable "UiWidget"

    @multiple_modules = null

    @module_classes = ko.computed => "module pk-item #{@module_sizes[@module_size()]} #{@widget_type()}"
    @value_classes = ko.computed => "#{@type()} #{@main_size()} #{@is_good()}"

#    @values = [{'value': 18931, 'label': "This Year", 'note': "$ of energy so far this year"},
#               {'value': 11255.75, 'label': "Last year", 'note': "$ of energy by this time last year"},
#              ]
#
#    @values = [{'value': 18931},
#              ]

    @value = ko.observable 0

    @note = ko.observable {}
      #"explanation": ko.observable "Total energy use for the year to date in $NZD"
      #"conversion": ko.observable "5 households worth of power"
      #"detail": ko.observable "Go team! Thus us rully gud!!"

    @note_array = ko.computed => make_note_array @note()

  init: () ->

class SmartWidget extends UiWidget
  constructor: ()->
    super()
    @building_tag = ko.observable null
    @hierarachy = ko.observable "main"   # The name of the hierarachy that we are referring to for data (typically main)
    @hierarachy_path = ko.observable "0" # Where in that hierarachy
    @interval_type = ko.observable "today"

    #@interval = ko.computed => get_interval(@interval_type(), new Date("2014-02-03 13:40"))
    @interval = ko.computed => get_interval(@interval_type(), new Date())

    @data_span = ko.observable 120 * 60

    @comp_note_kwh = ko.observable false
    @comp_note_price = ko.observable false
    @comp_budget = ko.observable undefined #If a value, use for comparisons

    @summary_type = ko.observable "kwh" # One of min, max, mean, total, kwh, price

    @unit = ko.observable "watts"
    @unit_suffix = ko.computed gs.common.defer => @primary_sensor()?.units
    @unit_detail = @unit_suffix
    @statistics = ko.computed gs.common.defer =>
      {start:start, end:end} = @interval()
      return @statistics_for(start, end)

    @prev_statistics = ko.computed gs.common.defer =>
      {prev_start:start, prev_end:end} = @interval()
      return @statistics_for(start, end)

    @note_array = ko.computed gs.common.defer =>
      notes = {}
      if @comp_note_kwh()
        now = @statistics()['kwh']
        prev = @prev_statistics()['kwh']
        if now > prev
          notes["comparison bad"] = "#{(now - prev).toFixed(1)}kWh more than #{@interval().comp_str}"
        else
          notes["comparison good"] = "#{(prev - now).toFixed(1)}kWh less than #{@interval().comp_str}"

      else if @comp_note_price()
        now = @statistics()['price']
        prev = @prev_statistics()['price']
        if now > prev
          notes["comparison bad"] = "$#{(now - prev).toFixed(2)} more than #{@interval().comp_str}"
        else
          notes["comparison good"] = "$#{(prev - now).toFixed(2)} less than #{@interval().comp_str}"

      $.extend notes, @note()
      return make_note_array notes

    @curr_building = ko.computed =>
      if @building_tag()?
        gs.bindings.bdgs.by_tag(@building_tag())
      else
        gs.bindings.curr_building()

  init: () ->
    # Called after member variables overridden by config.


  better_than_prev: () ->
    now = @statistics()[@summary_type()]
    prev = @prev_statistics()[@summary_type()]

    return now < prev

  statistics_for: (start, end) ->
    if gs.loading_mgr.loading()
      return {min: null, max: null, mean: null, totals: null, kwh: null, price:null};
    sensor = @primary_sensor()
    cursor = new gs.DataCursor(sensor, @unit())

    [data, complete] = cursor.get_data start, end, @data_span(), [sensor]
    #console?.log @title(), sensor.name(), "Loading done: #{complete}", start, end

    rounding = 1

    return gs.calculate_statistics(data, start, end, rounding, @curr_building().consts().price_kwh)

  sensor_node: ()->
    if @building_tag()?
      building = gs.bindings.building_list.by_tag(@building_tag)
    else
      building = gs.bindings.curr_building()

    return null unless building?

    tree = building.trees[@hierarachy()]
    return null unless tree?

    node = tree.find(@hierarachy_path())
    return node

  primary_sensor: ()->
    return @sensor_node()

  child_sensors: ()->
    return @sensor_node()?.sensors()


class TotalUsage extends SmartWidget
  constructor: ()->
    super()

    @title = ko.computed => "Total #{@primary_sensor()?.name()} Use"
    @type "number"

    @unit_suffix = ko.observable "kWh"
    @unit_detail = @unit_suffix

    @value = ko.computed gs.common.defer =>
      return @statistics()[@summary_type()]

class DerivedValue extends TotalUsage
  constructor: ()->
    super()

    @div = ko.observable 1
    @mul = ko.computed => 1/@div()

    @value = ko.computed gs.common.defer =>
      val = @statistics()[@summary_type()] * @mul()
      return val.toFixed(2)


class GraphUsage extends SmartWidget
  constructor: () ->
    super()
    @freq = null
    @module_height 5
    @context = null
    @context_mgr = new gs.ContextMgr(gs.bindings)

  init: () ->
    @context = new gs.TreeContext(@context_mgr, @primary_sensor())
    if @freq?
      @context = @freq

    @context_mgr.start @interval().start
    @context_mgr.end @interval().end

    #sensors:[primary_sensor()], refresh:10, date:interval().start, end_date:interval().end, freq: freq()

class CompareSymbol extends SmartWidget
  constructor: ()->
    super()

    @module_height 3
    @is_good = ko.computed gs.common.defer =>
      if @better_than_prev() then "good" else "bad"

    @value_classes = ko.computed => "#{@type()} #{@main_size()} symbol #{@is_good()}"

class ComparePercent extends SmartWidget
  constructor: ()->
    super()

    @title = ko.computed => "Savings #{@primary_sensor()?.name()} Use"
    @type "number"
    @module_height = ko.computed => if @module_size() >= 2 then 3 else 4

    @unit_suffix = ko.observable "kWh"
    @unit_detail = @unit_suffix

    @value = ko.computed gs.common.defer =>
      return @statistics()[@summary_type()]

    @prev_value = ko.computed gs.common.defer =>
      return @prev_statistics()[@summary_type()]

    @multiple_modules = ko.computed => [
      {
        sub_title: @interval().title
        unit_prefix: @unit_prefix
        value: @value
        unit_suffix: @unit_suffix
        value_classes: @value_classes
        note_array: make_note_array {
#          explanation: "Total energy use for the year to date in #{@unit_detail()}"
        }
      },
      {
        sub_title: @interval().prev_title
        unit_prefix: @unit_prefix
        value: @prev_value
        unit_suffix: @unit_suffix
        value_classes: @value_classes
        note_array: make_note_array {
#          explanation: "Total energy use for previous year in #{@unit_detail()}"
        }
      }
    ]

class CompareUsage extends SmartWidget
  constructor: ()->
    super()

    @title = ko.computed => "Total #{@primary_sensor()?.name()} Use"
    @type "number"
    @module_height = ko.computed => if @module_size() >= 2 then 3 else 4

    @unit_suffix = ko.observable "kWh"
    @unit_detail = @unit_suffix

    @value = ko.computed gs.common.defer =>
      return @statistics()[@summary_type()]

    @prev_value = ko.computed gs.common.defer =>
      return @prev_statistics()[@summary_type()]

    @multiple_modules = ko.computed => [
      {
        sub_title: @interval().title
        unit_prefix: @unit_prefix
        value: @value
        unit_suffix: @unit_suffix
        value_classes: @value_classes
        note_array: make_note_array {
#          explanation: "Total energy use for the year to date in #{@unit_detail()}"
        }
      },
      {
        sub_title: @interval().prev_title
        unit_prefix: @unit_prefix
        value: @prev_value
        unit_suffix: @unit_suffix
        value_classes: @value_classes
        note_array: make_note_array {
#          explanation: "Total energy use for previous year in #{@unit_detail()}"
        }
      }
    ]

# Live Energy usage per student in Dollars (variables : cost per kWh, "students", num students)
#

class SummaryView
  constructor: (static_widgets)->
    @desc = ko.observable "GwinSpy"
    @page_heading = ko.observable "Summarise your exectutives"
    @widgets = ko.observableArray []
    @layouts = ko.observable {}
    @layout = ko.computed
      read: =>
        curr_layout = "default" # some logic here to detect screen size
        return @layouts()[curr_layout]
      write: (value) =>
        # To be called when the user drags and drops widgets around.
        curr_layout = "default" # some logic here to detect screen size
        layouts_obj = @layouts()
        layouts_obj[curr_layout] = value
        @layouts(layouts_obj)


    @load static_widgets

  load: (data) ->
    widgets = []
    #TODO: Rather than replacing widgets during load, update them.
    if data["layouts"]?
      @layouts data["layouts"]
    else
      @layouts {}

    for widget in data['widgets']
      new_widget = switch widget.widget_type
        when "TotalUsage" then new TotalUsage()
        when "CompareUsage" then new CompareUsage()
        when "GraphUsage" then new GraphUsage()
        when "CompareSymbol" then new CompareSymbol()
        when "DerivedValue" then new DerivedValue()
        else new UiWidget()

      ko.mapping.fromJS widget, {}, new_widget

      new_widget.init()
      widgets.push(new_widget)

    @widgets widgets



ko.bindingHandlers.pk_list =
  init: (element, valueAccessor, allBindings, viewModel, bindingContext) ->
    # This will be called when the binding is first applied to an element
    # Set up any initial state, event handlers, etc. here

    # Tell child PK items where their parents are.
    # Make a modified binding context, with a extra properties, and apply it to descendant elements

    value = ko.unwrap(valueAccessor())
#    options_ko = value['options'] or {}
#
#    draggable = ko.unwrap(value['draggable'])
#    draggable = true unless draggable?
#
#    #Strip out any observables in the options
#    options = ko.toJS(options_ko)

    # Should bind a handler to resize as per : http://api.jquery.com/resize/
    # Choose dimensions based on screen size.

    gridster_options =
      widget_margins: [5, 5]
      widget_base_dimensions: [220, 50]
      autogenerate_stylesheet : false
      draggable:
        stop: (event, ui)->
          value = ko.unwrap(valueAccessor())
          layout = value["layout"]
          if value["layout"]?
            gridster_layout = gridster.serialize()
            console?.log "Drag-Drop: layout updated from ", value["layout"](), " to ", gridster_layout
            layout(gridster_layout)

    gridster = $(element).gridster(
      gridster_options
    ).addClass("gridster").data('gridster')


#    $(window).resize ->
#      $e = $(element)
#      width = $e.width()
#      height = $e.height()
#      console?.log "pk_plist size is now", width, "x", height
#
#      #gridster.options.widget_base_dimensions[0] = (width / 4) - 5
#      #gridster.min_widget_width = (gridster.options.widget_margins[0] * 2) +
#      #                             gridster.options.widget_base_dimensions[0]
#
#      #gridster.recalculate_faux_grid()
#      #gridster.draggable()
#
#      #gridster_options.widget_base_dimensions = [(width / 4) - 5, 50]
#      #console?.log gridster_options
#      #gridster = $e.gridster(
#      #  gridster_options
#      #)
#
#      return null

    #console?.log "Stored layout", ko.unwrap(value["layout"])
    innerBindingContext = bindingContext.extend(()->
      pk_parent:element
      pk_layout:value["layout"]
    )
    ko.applyBindingsToDescendants innerBindingContext, element

    # Also tell KO *not* to bind the descendants itself, otherwise they will be bound twice
    return { controlsDescendantBindings: true }

  update: (element, valueAccessor, allBindings, viewModel, bindingContext) ->
    # This will be called once when the binding is first applied to an element,
    # and again whenever the associated observable changes value.
    # Update the DOM element based on the supplied values here.

    gridster = $(element).data('gridster')

    gridster_layout = gridster.serialize()
    #console?.log "Layout is", ko.toJSON(gridster_layout)

    value = ko.unwrap(valueAccessor())
    if value["layout"]?
      layout = value["layout"]()
      if not layout? or layout.length == 0
        #console?.log "Overrode stored layout, which was:", layout
        if ko.isWriteableObservable(layout)
          layout(gridster_layout)

ko.bindingHandlers.pk_item =
  init: (element, valueAccessor, allBindings, viewModel, bindingContext) ->
    # This will be called when the binding is first applied to an element
    # Set up any initial state, event handlers, etc. here
    #value = ko.unwrap(valueAccessor())
    parent = bindingContext['pk_parent']
    layout = ko.unwrap(bindingContext['pk_layout'])

    gridster = $(parent).data('gridster')

    value = ko.unwrap(valueAccessor())
    layout_idx = ko.unwrap(value['idx'])

    if layout? and layout[layout_idx]?
      our_layout = ko.unwrap(layout[layout_idx])
    else
      our_layout = {}

    size_x = ko.unwrap(value['size_x']) || ko.unwrap(our_layout['size_x']?) || (1);
    size_y = ko.unwrap(value['size_y']) || ko.unwrap(our_layout['size_y']?)|| (1);

    if our_layout['col']? and our_layout['row']
      #console?.log "Using stored layout for widget", layout_idx, our_layout

      pos =
        col: our_layout['col']
        row: our_layout['row']

      gridster.empty_cells(pos.col, pos.row, size_x, size_y)
    else
      pos = gridster.next_position(size_x, size_y);
#    }else{
#        pos = {
#            col: col,
#            row: row
#        };
#
#        this.empty_cells(col, row, size_x, size_y);
#    }

    $w = $(element).attr({
            'data-col': pos.col,
            'data-row': pos.row,
            'data-sizex' : size_x,
            'data-sizey' : size_y
        }).addClass('gs-w')#.hide();

    gridster.$widgets = gridster.$widgets.add($w);
    gridster.register_widget($w);
    gridster.add_faux_rows(pos.size_y);

#    if (max_size) {
#        this.set_widget_max_size($w, max_size);
#    }

    gridster.set_dom_grid_height();

    #return $w.fadeIn();

    #gridster.add_widget(element)

  update: (element, valueAccessor, allBindings, viewModel, bindingContext) ->
    # This will be called once when the binding is first applied to an element,
    # and again whenever the associated observable changes value.
    # Update the DOM element based on the supplied values here.




window.gs.SummaryView = SummaryView
window.gs.summary.get_interval = get_interval

# {
#          "main_size": "big",
#          "title": "Total energy use",
#          "module_height": 4,
#          "value": 46925.32,
#          "is_good": "good",
#          "note": {
#            "comparison good": "10,544 kWh less than this time last year",
#            "explanation": "Total energy use for the year to date in kWh",
#            "conversion": "5 households worth of power",
#            "detail": "Go team! Thus us rully gud!!"
#          },
#          "unit_suffix": "kWh",
#          "type": "number",
#          "unit_detail": "kWh"
#        },
#        {
#          "main_size": "big",
#          "title": "Big energy use",
#          "module_height": 4,
#          "value": 46925.32,
#          "is_good": "good",
#          "note": {
#            "comparison good": "10,544 kWh less than this time last year",
#            "explanation": "Total energy use for the year to date in kWh",
#            "conversion": "5 households worth of power",
#            "detail": "Go team! Thus us rully gud!!"
#          },
#          "unit_suffix": "kWh",
#          "module_size": 2,
#          "type": "number",
#          "unit_detail": "kWh"
#        },
#        {
#          "main_size": "big",
#          "title": "Total energy use",
#          "module_height": 4,
#          "value": 46925.32,
#          "is_good": "good",
#          "note": {
#            "comparison good": "10,544 kWh less than this time last year",
#            "explanation": "Total energy use for the year to date in kWh",
#            "conversion": "5 households worth of power",
#            "detail": "Go team! Thus us rully gud!!"
#          },
#          "unit_suffix": "kWh",
#          "module_size": 2,
#          "type": "number",
#          "unit_detail": "kWh"
#        }
